/**
 * 🧑‍💻 «دستیار گروه‌ها»
 *
 * چند حساب شخصی تلگرام که در گروه‌های آرایشی و زیبایی عضوند و — فقط وقتی کسی واقعاً دنبال
 * خرید محصول آرایشی و بهداشتی است — مثل یک آدم راهنمایی می‌کنند. هیچ پیامی بدون عبور از
 * فیلتر محلی، دروازه‌بان و نویسنده ارسال نمی‌شود؛ در حالت پیش‌فرض هر پاسخ اول
 * به همین صفحه می‌آید تا ادمین تأیید کند.
 *
 * زبان بصری = همان کیت صفحهٔ حسابداری (FinanceAccounting.css / FinanceAccountingKit):
 * ناوبری گروهی بدون اسکرول، کاشی‌های شاخص، توضیح زبان‌ساده، جمله‌های خودکار، کارت‌ها.
 */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  Alert, Box, Button, CircularProgress, Dialog, DialogActions,
  DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, InputLabel,
  MenuItem, Select, Stack, Switch, TextField, Tooltip, Typography, alpha,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import RefreshIcon from '@mui/icons-material/Refresh';
import GroupsIcon from '@mui/icons-material/Groups';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import SyncIcon from '@mui/icons-material/Sync';
import EditIcon from '@mui/icons-material/Edit';
import SendIcon from '@mui/icons-material/Send';
import ScienceIcon from '@mui/icons-material/Science';
import SaveIcon from '@mui/icons-material/Save';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import ForumRoundedIcon from '@mui/icons-material/ForumRounded';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import DraftsRoundedIcon from '@mui/icons-material/DraftsRounded';
import InsightsRoundedIcon from '@mui/icons-material/InsightsRounded';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import HistoryToggleOffRoundedIcon from '@mui/icons-material/HistoryToggleOffRounded';
import SmartToyRoundedIcon from '@mui/icons-material/SmartToyRounded';
import PlaylistAddCheckRoundedIcon from '@mui/icons-material/PlaylistAddCheckRounded';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { ConfirmDialog } from '../components/common';
import UserbotConversations from '../components/userbot/UserbotConversations';
import DraftsTab from '../components/userbot/DraftsTab';
import SettingsTab from '../components/userbot/SettingsTab';
import InsightsTab from '../components/userbot/InsightsTab';
import ChannelsTab from '../components/userbot/ChannelsTab';
import {
  ACCOUNT_STATUS_FA, Bubble, Dot, EmptyHint, INTENT_FA, IconAction, Loading, Pill, STAGE_FA,
  LocalChips, Tag, UB, errMsg, fa, faDate, hueOf, initial, relTime,
} from '../components/userbot/kit';
import { Explain, Kpis, Insights, Card, Tag as FacTag } from './FinanceAccountingKit';
import type { Tone } from './FinanceAccountingKit';
import userbotService, {
  UserbotAccount, UserbotDryRun, UserbotGroup, UserbotOverview,
} from '../services/userbotService';
import './EntityManagement.css';
import './FinanceAccounting.css';

// ------------------------------------------------------------------ helpers

type TabKey = 'overview' | 'accounts' | 'groups' | 'channels' | 'conversations' | 'drafts' | 'insights' | 'settings' | 'test';
type TabGroup = 'daily' | 'telegram' | 'setup';
const TAB_GROUPS: Array<{ key: TabGroup; label: string; hint: string }> = [
  { key: 'daily', label: 'کار روزانه', hint: 'چه گذشت و چه باید تأیید شود' },
  { key: 'telegram', label: 'تلگرام', hint: 'حساب‌ها و جاهایی که عضوند' },
  { key: 'setup', label: 'تنظیم و آزمایش', hint: 'هوش مصنوعی، رفتار، تست' },
];
const TABS: Array<{ key: TabKey; group: TabGroup; label: string; hint: string; Icon: React.ElementType }> = [
  { key: 'overview', group: 'daily', label: 'نمای کلی', hint: 'دستیار الان چه حالی دارد؟', Icon: DashboardRoundedIcon },
  { key: 'drafts', group: 'daily', label: 'پیش‌نویس‌ها', hint: 'جواب‌هایی که منتظر تأیید شما هستند', Icon: DraftsRoundedIcon },
  { key: 'conversations', group: 'daily', label: 'گفتگوها', hint: 'با هر آدم چه رد و بدل شده', Icon: ForumRoundedIcon },
  { key: 'insights', group: 'daily', label: 'تحلیل بازار', hint: 'مردم دنبال چه‌اند و شما چه کار کنید', Icon: InsightsRoundedIcon },
  { key: 'accounts', group: 'telegram', label: 'حساب‌ها', hint: 'شماره‌های تلگرامی که دستیار با آن‌ها حرف می‌زند', Icon: PersonRoundedIcon },
  { key: 'groups', group: 'telegram', label: 'گروه‌ها', hint: 'کجا اجازه دارد جواب بدهد', Icon: GroupsIcon },
  { key: 'channels', group: 'telegram', label: 'کانال‌ها', hint: 'فقط برای خواندن بازار و قیمت‌ها', Icon: CampaignOutlinedIcon },
  { key: 'settings', group: 'setup', label: 'تنظیمات', hint: 'اتصال، هوش مصنوعی، شخصیت، رفتار', Icon: TuneRoundedIcon },
  { key: 'test', group: 'setup', label: 'آزمایش', hint: 'یک پیام فرضی بده و ببین چه می‌کند', Icon: ScienceIcon },
];

const STATUS_FA = ACCOUNT_STATUS_FA;
const LS_UB_BEGINNER = 'ubc-beginner-mode';
const useBeginnerUb = () => {
  const [on, setOn] = useState<boolean>(() => { try { return localStorage.getItem(LS_UB_BEGINNER) !== '0'; } catch { return true; } });
  const toggle = () => setOn((v) => { try { localStorage.setItem(LS_UB_BEGINNER, v ? '0' : '1'); } catch { /* ignore */ } return !v; });
  return { on, toggle };
};

/** توضیح زبان‌ساده برای هر تب — فقط وقتی «راهنمای مبتدی» روشن است */
const TAB_EXPLAIN: Record<TabKey, { title: string; text: React.ReactNode; how?: string[] }> = {
  overview: { title: 'این صفحه چیست؟', text: <>چند <b>حساب شخصی تلگرام</b> (نه ربات) در گروه‌های آرایشی و زیبایی عضوند. وقتی کسی واقعاً می‌پرسد «این کرم اصل از کجا بخرم؟ / ضدآفتاب خوب چی بگیرم؟»، دستیار مثل یک آدم راهنمایی می‌کند و در جواب‌های بعدی کازماشاپ را معرفی می‌کند. هیچ پیامی بدون سه مرحلهٔ بررسی فرستاده نمی‌شود و در حالت پیش‌فرض جواب اول به همین‌جا می‌آید تا شما تأیید کنید.</>, how: ['کاشی‌های بالا وضعیت همین لحظه‌اند؛ روی هرکدام کلیک کنید به بخش مربوطه می‌رود.', 'اگر «مشکل» دیدید، همان بالا نوشته چه چیزی باید درست شود.', 'کلید اصلی بالای صفحه همه‌چیز را یک‌جا خاموش/روشن می‌کند.'] },
  drafts: { title: 'پیش‌نویس یعنی چه؟', text: <>هر پیامی که از فیلترها گذشته و هوش مصنوعی برایش جواب نوشته، اینجا به‌صورت <b>پیش‌نویس</b> می‌نشیند. شما جواب را می‌خوانید، اگر خواستید ویرایش می‌کنید و «تأیید» می‌زنید تا با تأخیر طبیعی فرستاده شود. گروه‌هایی که «ارسال خودکار» دارند از این مرحله رد می‌شوند.</>, how: ['روی هر خط کلیک کنید: پیام اصلی، تحلیل، گفتگوی قبلی و متن قابل‌ویرایش را می‌بینید.', '«رد» یعنی هیچ‌وقت فرستاده نشود؛ پیش‌نویس‌های قدیمی خودشان منقضی می‌شوند.'] },
  conversations: { title: 'گفتگوها چیست؟', text: <>برای هر آدمی که دستیار با او حرف زده، یک <b>پرونده</b> نگه می‌داریم: چه گفته، ما چه جواب دادیم، دنبال چه چیزی است (محصول، برند، نوع پوست، بودجه) و آیا کازماشاپ معرفی شده یا نه. هوش مصنوعی در جواب‌های بعدی از همین حافظه استفاده می‌کند.</>, how: ['مرحلهٔ هر گفتگو (تازه، در حال گفتگو، معرفی‌شده، پیگیر) خودکار به‌روز می‌شود؛ می‌توانید دستی هم عوض کنید.', 'یادداشت بگذارید تا در جواب‌های بعدی لحاظ شود.'] },
  insights: { title: 'تحلیل بازار چیست؟', text: <>هر شب ساعت ۲۳ همهٔ پیام‌های بازارِ آن روز (حتی آن‌هایی که جواب نگرفتند) خلاصه می‌شود: <b>مردم دنبال چه بودند</b>، چه محصولی کم است، چه مشکلی تکرار شد و <b>فردا چه کار کنید</b>. منبع «گروه‌ها» تقاضا را نشان می‌دهد و «کانال‌ها» عرضه و قیمت رقبا را.</>, how: ['چک‌لیست کارها را می‌توانید انجام‌شده/رهاشده بزنید.', 'دکمهٔ «تحلیل امروز را الان بساز» بدون انتظار تا شب گزارش می‌سازد (هزینهٔ AI دارد).'] },
  accounts: { title: 'حساب یعنی چه؟', text: <>هر حساب یک <b>شمارهٔ واقعی تلگرام</b> است که دستیار با هویت آن در گروه‌ها حرف می‌زند. بعد از افزودن باید یک بار «ورود» بزنید (کد پیامکی و در صورت نیاز رمز دومرحله‌ای). چند حساب داشته باشید تا اگر یکی محدود شد، دیگری ادامه دهد؛ هیچ‌وقت دو حساب هم‌زمان با یک نفر حرف نمی‌زنند.</>, how: ['«گروه‌ها و کانال‌ها» عضویت‌های حساب را از تلگرام می‌خواند تا در تب‌های بعدی انتخاب کنید.', '«شخصیت و سقف‌ها» اسم، لحن و حداکثر پیام در روز را تعیین می‌کند.'] },
  groups: { title: 'گروه‌ها چطور کار می‌کنند؟', text: <>گروه‌ها از عضویت‌های حساب‌ها کشف می‌شوند. تا یک گروه را <b>فعال</b> نکنید، دستیار فقط می‌خواند و هیچ جوابی نمی‌دهد. برای هر گروه می‌توانید حالت (پیش‌نویس با تأیید یا ارسال خودکار)، سخت‌گیری و یادداشت زمینه (مثلاً «این گروه فقط مراقبت پوست») تعیین کنید.</>, how: ['شمارنده‌های هر گروه: دیده، کاندیدا، تأیید دروازه‌بان، ارسال.', '«خروج و حذف» حساب‌ها را واقعاً از گروه بیرون می‌برد؛ «فقط از فهرست» نه.'] },
  channels: { title: 'کانال‌ها برای چیست؟', text: <>در کانال‌ها دستیار <b>هیچ‌وقت پیام نمی‌دهد</b>؛ فقط پست‌ها را می‌خواند تا بفهمیم بازار چه عرضه می‌کند و به چه قیمتی: کانال رقبا، خبر، فروش. این داده به «تحلیل بازار (منبع کانال‌ها)» می‌رود.</>, how: ['با لینک یا یوزرنیم اضافه کنید؛ دسته (رقیب/خبر/بازار) به هوش مصنوعی کمک می‌کند.', 'خروج دسته‌ای پنج‌تا پنج‌تا انجام می‌شود تا تلگرام محدود نکند.'] },
  settings: { title: 'در تنظیمات چه چیزی هست؟', text: <>پنج دسته: <b>اتصال</b> (api_id و api_hash از my.telegram.org)، <b>هوش مصنوعی</b> (سرویس اصلی، پشتیبان‌ها، بودجهٔ روزانه، مدل‌ها)، <b>فیلتر و آستانه‌ها</b> (کی ارزش دارد به مدل بگوییم)، <b>شخصیت</b> (قواعد رفتاری و حقایق سایت) و <b>رفتار</b> (تأخیرها، سقف‌ها، دایرکت).</>, how: ['تغییرات تا «ذخیره» نزنید اعمال نمی‌شوند؛ نوار پایین یادآوری می‌کند.', 'اگر سرویس هوش مصنوعی خطا داد، بخش «جابه‌جایی سرویس» خودکار به پشتیبان می‌رود.'] },
  test: { title: 'آزمایش چیست؟', text: <>یک پیام فرضی بنویسید و ببینید دستیار با آن چه می‌کند: فیلتر محلی چه فهمید، دروازه‌بان اجازه داد یا نه، و نویسنده چه جوابی نوشت. <b>هیچ‌چیز به تلگرام فرستاده نمی‌شود</b>، ولی هزینهٔ واقعی هوش مصنوعی دارد.</>, how: ['پیام‌های قبلی را هم می‌توانید بدهید تا حافظهٔ گفتگو تست شود.', 'گروه را انتخاب کنید تا یادداشت و سخت‌گیری همان گروه اعمال شود.'] },
};

// ------------------------------------------------------------------ page

const UserbotCenter: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [params, setParams] = useSearchParams();
  const tab = (params.get('tab') as TabKey) || 'overview';
  const setTab = (k: TabKey) => setParams({ tab: k });
  const beginner = useBeginnerUb();
  const [glossary, setGlossary] = useState(false);

  const [overview, setOverview] = useState<UserbotOverview | null>(null);
  const [loading, setLoading] = useState(true);

  const loadOverview = useCallback(async (silent = false) => {
    if (!silent) setLoading(true);
    try {
      setOverview(await userbotService.overview());
    } catch (e) {
      enqueueSnackbar(errMsg(e, 'خطا در دریافت وضعیت دستیار'), { variant: 'error' });
    } finally {
      setLoading(false);
    }
  }, [enqueueSnackbar]);

  useEffect(() => { loadOverview(); }, [loadOverview]);
  useEffect(() => {
    const t = setInterval(() => loadOverview(true), 30000);
    return () => clearInterval(t);
  }, [loadOverview]);

  const toggleEnabled = async (enabled: boolean) => {
    try {
      await userbotService.updateSettings({ enabled });
      enqueueSnackbar(enabled ? 'دستیار روشن شد' : 'دستیار خاموش شد', { variant: 'success' });
      loadOverview(true);
    } catch (e) {
      enqueueSnackbar(errMsg(e), { variant: 'error' });
    }
  };

  if (loading && !overview) return <Loading size={30} />;

  const problems = overview?.problems || [];
  const on = !!overview?.settings.enabled;
  const budget = overview?.ai.dailyBudgetUsd || 0;
  const spent = overview?.ai.spentTodayUsd || 0;
  const Current = TABS.find((t) => t.key === tab) || TABS[0];
  const ex = TAB_EXPLAIN[Current.key];
  const badgeOf = (k: TabKey): number => (k === 'drafts' ? overview?.counts.pending || 0 : k === 'groups' ? overview?.counts.groupsEnabled || 0 : 0);

  return (
    <div className="entity-page fac-page" dir="rtl">
      {/* ───────── سربرگ ───────── */}
      <div className="fac-head">
        <div>
          <h1 className="fac-head-title"><SmartToyRoundedIcon />دستیار گروه‌ها
            <span className={`fac-tag ${!on ? 'gray' : problems.length ? 'orange' : 'green'}`} style={{ marginInlineStart: 6 }}>{!on ? 'خاموش' : problems.length ? `${fa(problems.length)} مشکل` : 'در حال کار'}</span>
          </h1>
          <p className="fac-head-sub">حساب‌های شخصی تلگرام در گروه‌های آرایشی و زیبایی؛ فقط به سؤال واقعی خرید محصول، مثل یک آدم جواب می‌دهند.</p>
        </div>
        <div className="fac-head-tools">
          {overview && (
            <Tooltip title={on ? 'دستیار روشن است — برای توقف همه‌چیز خاموش کنید' : 'دستیار خاموش است — هیچ پیامی پردازش نمی‌شود'} arrow>
              <span className={`fac-switch ${on ? 'on' : ''}`} onClick={() => toggleEnabled(!on)}><i />کلید اصلی</span>
            </Tooltip>
          )}
          <Tooltip title="توضیح زبان‌ساده بالای هر بخش" arrow><span className={`fac-switch ${beginner.on ? 'on' : ''}`} onClick={beginner.toggle}><i />راهنمای مبتدی</span></Tooltip>
          <span className={`fac-switch ${glossary ? 'on' : ''}`} onClick={() => setGlossary(!glossary)}><MenuBookIcon style={{ fontSize: 16 }} />واژه‌نامه</span>
          <button className="header-btn refresh" onClick={() => loadOverview()} title="بروزرسانی"><RefreshIcon fontSize="small" /></button>
        </div>
      </div>

      {/* ───────── نوار سلامت ───────── */}
      {overview && (
        <div className="fac-card" style={{ marginBottom: 12 }}>
          <div className="fac-card-body" style={{ display: 'flex', gap: '10px 22px', flexWrap: 'wrap', alignItems: 'center', padding: '10px 16px' }}>
            <Dot
              ok={overview.ai.apiKeyConfigured}
              label={overview.ai.providerLabel || (overview.ai.provider === 'openai' ? 'ارائه‌دهندهٔ هوش مصنوعی' : 'کلید هوش مصنوعی')}
              hint={overview.ai.unavailableReason || `مدل‌ها از ${overview.ai.providerLabel || 'Anthropic'} گرفته می‌شوند${overview.ai.baseUrl ? ` (${overview.ai.baseUrl})` : ''}`}
            />
            <Dot ok={overview.bridge.ok} label="سرویس ربات" hint={overview.bridge.message} />
            <Dot ok={!!overview.settings.apiId && overview.settings.apiHashConfigured} label="api_id تلگرام" hint="از my.telegram.org" />
            <Dot ok={!overview.ai.breakerOpen} label="اتصال سالم" warn={overview.ai.breakerOpen} hint={overview.ai.breakerOpen ? 'به‌دلیل خطاهای پیاپی موقتاً متوقف' : 'بدون خطای پیاپی'} />
            {overview.ai.usingOverride && <Dot ok={false} warn label="سرویس جایگزین" hint="سرویس اصلی جواب نداد؛ به‌محض برگشتنش خودکار برمی‌گردیم." />}
            <span style={{ flex: 1, minWidth: 8 }} />
            <div style={{ minWidth: 200 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, marginBottom: 4 }}>
                <span className="fac-muted">مصرف هوش مصنوعی امروز</span>
                <b>{fa(spent.toFixed(3))}$ / {budget ? `${fa(budget)}$` : '∞'}</b>
              </div>
              <div className="fac-meter" style={{ background: 'var(--color-bg-default)' }}><i style={{ width: `${budget ? Math.min(100, (spent / budget) * 100) : 0}%`, background: overview.ai.budgetExceeded ? 'var(--color-error)' : 'var(--color-primary)' }} /></div>
            </div>
          </div>
        </div>
      )}

      {/* ───────── ناوبری گروهی (بدون اسکرول) ───────── */}
      <nav className="fac-nav" aria-label="بخش‌های دستیار">
        {TAB_GROUPS.map((g) => (
          <div key={g.key} className={`fac-nav-group ${Current.group === g.key ? 'active' : ''}`}>
            <div className="fac-nav-group-head"><b>{g.label}</b><span>{g.hint}</span></div>
            <div className="fac-nav-items">
              {TABS.filter((t) => t.group === g.key).map(({ key, label, Icon }) => {
                const badge = badgeOf(key);
                return (
                  <button key={key} type="button" className={`fac-tab ${tab === key ? 'active' : ''}`} onClick={() => setTab(key)}>
                    <Icon />{label}
                    {!!badge && <span className="fac-tab-badge" style={key === 'groups' ? { background: 'var(--color-primary-dark)' } : undefined}>{fa(badge)}</span>}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </nav>

      {glossary && (
        <Card title="واژه‌نامهٔ دستیار به زبان ساده" icon={<MenuBookIcon />} actions={<Button size="small" onClick={() => setGlossary(false)}>بستن</Button>}>
          <div className="fac-glossary">{UB_GLOSSARY.map(([t, d]) => <div key={t} className="fac-term"><b>{t}</b><span>{d}</span></div>)}</div>
        </Card>
      )}

      <div className="fac-current"><Current.Icon /><div><b>{Current.label}</b><span>{Current.hint}</span></div></div>
      <Explain show={beginner.on} title={ex.title} text={ex.text} how={ex.how} />

      {tab === 'overview' && overview && <OverviewTab data={overview} onGo={setTab} onRefresh={() => loadOverview(true)} />}
      {tab === 'accounts' && <AccountsTab onChanged={() => loadOverview(true)} />}
      {tab === 'groups' && <GroupsTab />}
      {tab === 'channels' && <ChannelsTab />}
      {tab === 'conversations' && <UserbotConversations />}
      {tab === 'drafts' && <DraftsTab onChanged={() => loadOverview(true)} />}
      {tab === 'insights' && <InsightsTab />}
      {tab === 'settings' && overview && <SettingsTab initial={overview.settings} onSaved={() => loadOverview(true)} />}
      {tab === 'test' && <TestTab />}
    </div>
  );
};

const UB_GLOSSARY: Array<[string, string]> = [
  ['حساب شخصی', 'یک شمارهٔ واقعی تلگرام که دستیار با هویت آن در گروه‌ها پیام می‌دهد؛ ربات نیست.'],
  ['فیلتر محلی', 'اولین بررسی، بدون هوش مصنوعی و رایگان: آیا پیام اصلاً دربارهٔ خرید محصول آرایشی و بهداشتی است؟'],
  ['دروازه‌بان', 'مدل ارزان هوش مصنوعی که فقط تصمیم می‌گیرد «جواب بده یا نده».'],
  ['نویسنده', 'مدل قوی‌تر که متن جواب را با حافظهٔ گفتگوی همان شخص می‌نویسد.'],
  ['پیش‌نویس', 'جوابی که نوشته شده ولی هنوز فرستاده نشده و منتظر تأیید شماست.'],
  ['ارسال خودکار', 'حالتی برای هر گروه که جواب بدون تأیید شما، با تأخیر طبیعی فرستاده می‌شود.'],
  ['سرنخ / گفتگو', 'پروندهٔ یک آدم: پیام‌هایش، جواب‌های ما، چه می‌خواهد، آیا کازماشاپ معرفی شده.'],
  ['معرفی مرحله‌ای', 'کازماشاپ هیچ‌وقت در اولین جواب گفته نمی‌شود؛ از جواب دوم یا وقتی طرف بپرسد «از کجا؟».'],
  ['سرویس پشتیبان', 'اگر سرویس هوش مصنوعی اصلی خطا/سهمیه داد، خودکار به سرویس بعدی می‌رویم.'],
  ['بودجهٔ روزانه', 'سقف دلاری مصرف هوش مصنوعی در روز؛ بعد از آن پیام‌ها منتظر می‌مانند.'],
  ['محدودیت (FloodWait)', 'تلگرام حساب را موقتاً از پیام‌دادن منع کرده؛ حساب دیگر جایگزین می‌شود.'],
  ['تحلیل بازار', 'گزارش شبانه از همهٔ پیام‌های بازار: تقاضا، محصول کم، مشکل تکراری، کارهای فردا.'],
  ['کانال', 'فقط خوانده می‌شود (قیمت و عرضهٔ رقبا)؛ دستیار در کانال هیچ‌وقت پیام نمی‌دهد.'],
];

// ------------------------------------------------------------------ نمای کلی

/** یک قدم از خط لوله */
const Step: React.FC<{ n: number; title: string; hint: string; icon: React.ReactNode; color: string }> = ({ n, title, hint, icon, color }) => (
  <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start', flex: '1 1 200px', minWidth: 180 }}>
    <div style={{ width: 34, height: 34, borderRadius: 10, flexShrink: 0, display: 'grid', placeItems: 'center', color, background: alpha(color, 0.12) }}>{icon}</div>
    <div style={{ minWidth: 0 }}>
      <div style={{ fontSize: 13, fontWeight: 800 }}><span className="fac-muted" style={{ marginInlineEnd: 4 }}>{fa(n)}.</span>{title}</div>
      <div className="fac-line-note">{hint}</div>
    </div>
  </div>
);

const OverviewTab: React.FC<{ data: UserbotOverview; onGo: (t: TabKey) => void; onRefresh: () => void }> = ({ data, onGo, onRefresh }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [reloading, setReloading] = useState(false);
  const [confirmReset, setConfirmReset] = useState(false);
  const resetMessages = async () => {
    setConfirmReset(false);
    try { enqueueSnackbar(await userbotService.resetMessages(), { variant: 'success' }); onRefresh(); }
    catch (e) { enqueueSnackbar(errMsg(e), { variant: 'error' }); }
  };
  const reload = async () => {
    setReloading(true);
    try { enqueueSnackbar(await userbotService.reload(), { variant: 'success' }); onRefresh(); }
    catch (e) { enqueueSnackbar(errMsg(e), { variant: 'error' }); }
    finally { setReloading(false); }
  };
  const c = data.counts;
  const on = !!data.settings.enabled;

  const insights = useMemo(() => {
    const out: Array<{ tone: Tone; text: React.ReactNode }> = [];
    if (!on) out.push({ tone: 'warn', text: <>دستیار <b>خاموش</b> است؛ هیچ پیامی خوانده یا جواب داده نمی‌شود. با «کلید اصلی» بالای صفحه روشن کنید.</> });
    for (const p of data.problems) out.push({ tone: 'bad', text: p });
    if (on && !data.problems.length) {
      if (!c.accountsOnline) out.push({ tone: 'warn', text: <>هیچ حسابی آنلاین نیست؛ تا یک حساب وارد نشود جوابی فرستاده نمی‌شود. <Button size="small" onClick={() => onGo('accounts')}>حساب‌ها</Button></> });
      else if (!c.groupsEnabled) out.push({ tone: 'warn', text: <>{fa(c.accountsOnline)} حساب آنلاین است ولی هیچ گروهی فعال نیست؛ در تب گروه‌ها دست‌کم یکی را روشن کنید. <Button size="small" onClick={() => onGo('groups')}>گروه‌ها</Button></> });
      else out.push({ tone: 'good', text: <>همه‌چیز آماده است: <b>{fa(c.accountsOnline)}</b> حساب آنلاین در <b>{fa(c.groupsEnabled)}</b> گروه فعال گوش می‌دهند. امروز <b>{fa(c.repliesToday)}</b> جواب داده شده و در ۲۴ ساعت گذشته <b>{fa(c.sentToday)}</b> پیام فرستاده شده است.</> });
    }
    if (c.pending > 0) out.push({ tone: 'warn', text: <><b>{fa(c.pending)}</b> جواب منتظر تأیید شماست؛ تا تأیید نکنید فرستاده نمی‌شوند و بعد از مدتی منقضی می‌شوند. <Button size="small" onClick={() => onGo('drafts')}>بررسی پیش‌نویس‌ها</Button></> });
    if ((c.waiting || 0) > 0) out.push({ tone: 'warn', text: <>{fa(c.waiting || 0)} پیام منتظر سالم‌شدن سرویس هوش مصنوعی است؛ بخش «جابه‌جایی سرویس» در تنظیمات را ببینید.</> });
    if (data.ai.budgetExceeded) out.push({ tone: 'bad', text: <>بودجهٔ روزانهٔ هوش مصنوعی تمام شده ({fa(data.ai.dailyBudgetUsd)}$)؛ تا فردا پیام‌ها منتظر می‌مانند مگر بودجه را در تنظیمات بالا ببرید.</> });
    if (c.skipped24h > 0 && c.sentToday + c.pending === 0 && on) out.push({ tone: 'info', text: <>در ۲۴ ساعت گذشته {fa(c.skipped24h)} پیام از فیلتر گذشت ولی دروازه‌بان همه را رد کرد؛ اگر حس می‌کنید زیادی سخت‌گیر است، آستانه را در تنظیمات پایین بیاورید.</> });
    return out;
  }, [data, c, on, onGo]);

  return (
    <>
      <Insights items={insights} />
      <Kpis items={[
        { label: 'حساب‌های آنلاین', raw: <>{fa(c.accountsOnline)} <span className="fac-muted">/ {fa(c.accounts)}</span></>, value: null, color: c.accountsOnline ? 'green' : 'red', help: 'حساب‌هایی که همین حالا به تلگرام وصل‌اند', sub: <span style={{ cursor: 'pointer', color: 'var(--color-primary)' }} onClick={() => onGo('accounts')}>مدیریت حساب‌ها</span> },
        { label: 'گروه‌های فعال', raw: <>{fa(c.groupsEnabled)} <span className="fac-muted">/ {fa(c.groups)}</span></>, value: null, color: c.groupsEnabled ? 'blue' : 'gray', help: 'گروه‌هایی که اجازهٔ جواب‌دادن دارند از کل گروه‌های کشف‌شده', sub: <span style={{ cursor: 'pointer', color: 'var(--color-primary)' }} onClick={() => onGo('groups')}>مدیریت گروه‌ها</span> },
        { label: 'جواب امروز', value: c.repliesToday, count: true, color: 'purple', help: 'مجموع جواب‌های همهٔ حساب‌ها از ابتدای امروز' },
        { label: 'ارسال ۲۴ ساعت', value: c.sentToday, count: true, color: 'green', help: 'پیام‌هایی که واقعاً به تلگرام رفت', sub: <span style={{ cursor: 'pointer', color: 'var(--color-primary)' }} onClick={() => onGo('drafts')}>دیدن ارسال‌شده‌ها</span> },
        { label: 'منتظر تأیید', value: c.pending, count: true, color: c.pending ? 'orange' : 'gray', help: 'پیش‌نویس‌هایی که فقط با تأیید شما فرستاده می‌شوند', sub: c.pending ? <span style={{ cursor: 'pointer', color: 'var(--color-primary)' }} onClick={() => onGo('drafts')}>بررسی کنید</span> : 'چیزی منتظر نیست' },
        { label: 'ردشده توسط مدل', value: c.skipped24h, count: true, color: 'gray', help: 'پیام‌هایی که از فیلتر گذشتند ولی دروازه‌بان گفت جواب نده (۲۴ ساعت)' },
        { label: 'پاسخ دایرکت', raw: c.dmEnabled ? fa(c.dmSentToday ?? 0) : 'خاموش', value: null, color: c.dmEnabled ? 'purple' : 'gray', help: 'جواب به پیام خصوصی افراد (۲۴ ساعت)', sub: c.dmEnabled ? undefined : <span style={{ cursor: 'pointer', color: 'var(--color-primary)' }} onClick={() => onGo('settings')}>در تنظیمات روشن کنید</span> },
      ]} />

      <Card title="مسیر هر پیام" sub="هیچ پیامی این چهار مرحله را دور نمی‌زند" icon={<BoltRoundedIcon />}>
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
          <Step n={1} color={UB.muted} icon={<TuneRoundedIcon />} title="فیلتر محلی" hint="بدون هوش مصنوعی و رایگان؛ بیشتر پیام‌ها همین‌جا رد می‌شوند." />
          <Step n={2} color={UB.info} icon={<SmartToyRoundedIcon />} title="دروازه‌بان" hint={`${data.settings.gateModel} — فقط تصمیم «جواب بده / نده».`} />
          <Step n={3} color={UB.accent} icon={<EditIcon />} title="نویسنده" hint={`${data.settings.writerModel} — با حافظهٔ گفتگوی همان شخص.`} />
          <Step n={4} color={UB.ok} icon={<SendIcon />} title={data.settings.defaultMode === 'auto' ? 'ارسال خودکار' : 'تأیید شما'} hint="با تأخیر و تایپینگ طبیعی؛ کازماشاپ از جواب دوم به بعد معرفی می‌شود." />
        </div>
      </Card>

      <Card title="فعالیت اخیر" sub="آخرین چیزهایی که دستیار نوشته یا فرستاده" icon={<HistoryToggleOffRoundedIcon />}
        actions={<>
          <Button size="small" onClick={() => onGo('drafts')}>همهٔ پیش‌نویس‌ها</Button>
          <Button size="small" variant="outlined" startIcon={reloading ? <CircularProgress size={13} /> : <SyncIcon />} disabled={reloading} onClick={reload}>بارگذاری مجدد سرویس ربات</Button>
          <Button size="small" color="error" startIcon={<DeleteOutlineIcon />} onClick={() => setConfirmReset(true)}>پاک‌کردن پیام‌ها</Button>
        </>}>
        {data.recent.length === 0 ? (
          <EmptyHint icon={<ForumRoundedIcon />} title="هنوز چیزی ثبت نشده" hint="وقتی در گروه‌های فعال پیام مرتبطی بیاید، این‌جا دیده می‌شود." />
        ) : (
          <div className="fac-rows-wrap"><div className="fac-rows" style={{ minWidth: 760 }}>
            {data.recent.map((d) => (
              <div key={d._id} className="fac-row" style={{ gridTemplateColumns: '130px minmax(160px, 1fr) minmax(220px, 2fr) 120px', cursor: 'default' }}>
                <span><Pill label={STAGE_FA[d.stage]?.label || d.stage} color={STAGE_FA[d.stage]?.color || UB.muted} /></span>
                <span className="fac-row-party"><b>{d.chatTitle || d.chatId}</b><small>{d.gate ? (INTENT_FA[d.gate.intent] || d.gate.intent) : ''}{d.accountId ? ` · ${d.accountId.label}` : ''}</small></span>
                <span className="fac-row-party"><b style={{ fontWeight: 500 }}>👤 {d.senderName}: {d.text}</b>{(d.final?.text || d.draft?.text) && <small style={{ color: 'var(--color-primary)' }}>↩︎ {d.final?.text || d.draft?.text}</small>}</span>
                <span className="fac-muted n" style={{ textAlign: 'left' }}>{relTime(d.updatedAt)}</span>
              </div>
            ))}
          </div></div>
        )}
        <ConfirmDialog
          open={confirmReset}
          title="ریست پیام‌های دستیار"
          message="همهٔ پیش‌نویس‌ها، گفتگوها و کاندیداها پاک، شمارنده‌های گروه‌ها صفر و فهرست پیام‌های زنده خالی می‌شود. حساب‌ها، گروه‌ها و تنظیمات دست نمی‌خورند."
          onConfirm={resetMessages}
          onCancel={() => setConfirmReset(false)}
        />
      </Card>
    </>
  );
};

// ------------------------------------------------------------------ حساب‌ها

const AccountsTab: React.FC<{ onChanged: () => void }> = ({ onChanged }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [rows, setRows] = useState<UserbotAccount[]>([]);
  const [loading, setLoading] = useState(true);
  const [addOpen, setAddOpen] = useState(false);
  const [edit, setEdit] = useState<UserbotAccount | null>(null);
  const [login, setLogin] = useState<UserbotAccount | null>(null);
  const [joinFor, setJoinFor] = useState<UserbotAccount | null>(null);
  const [confirmDel, setConfirmDel] = useState<UserbotAccount | null>(null);
  const [busy, setBusy] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    try { setRows(await userbotService.accounts()); }
    catch (e) { enqueueSnackbar(errMsg(e), { variant: 'error' }); }
    finally { setLoading(false); }
  }, [enqueueSnackbar]);
  useEffect(() => { load(); }, [load]);

  const run = async (id: string, fn: () => Promise<string | void>) => {
    setBusy(id);
    try { const m = await fn(); if (m) enqueueSnackbar(m, { variant: 'success' }); await load(); onChanged(); }
    catch (e) { enqueueSnackbar(errMsg(e), { variant: 'error' }); }
    finally { setBusy(null); }
  };

  const online = rows.filter((a) => a.online).length;
  const limitedCount = rows.filter((a) => a.floodWaitUntil && new Date(a.floodWaitUntil) > new Date()).length;
  return (
    <>
      {rows.length > 0 && (
        <Kpis items={[
          { label: 'حساب‌ها', value: rows.length, count: true, color: 'blue', sub: `${fa(rows.filter((a) => a.active).length)} روشن` },
          { label: 'آنلاین', value: online, count: true, color: online ? 'green' : 'red', help: 'وصل به تلگرام همین حالا' },
          { label: 'محدودشده', value: limitedCount, count: true, color: limitedCount ? 'orange' : 'gray', help: 'FloodWait از طرف تلگرام؛ خودکار برمی‌گردد' },
          { label: 'جواب امروز', value: rows.reduce((s, a) => s + (a.stats?.repliesToday ?? 0), 0), count: true, color: 'purple' },
        ]} />
      )}
      <Card title="حساب‌های شخصی" sub="هر حساب یک شمارهٔ واقعی تلگرام است؛ بعد از افزودن، «ورود» را بزنید" icon={<PersonRoundedIcon />}
        actions={<Button size="small" variant="contained" startIcon={<PersonAddIcon />} onClick={() => setAddOpen(true)}>افزودن حساب</Button>}>
        {loading && rows.length === 0 ? <Loading /> : rows.length === 0 ? (
          <EmptyHint icon={<PersonRoundedIcon />} title="هنوز حسابی ثبت نشده" hint="برای شروع، شمارهٔ یک حساب تلگرام را اضافه و وارد شوید." action={<Button variant="contained" size="small" startIcon={<PersonAddIcon />} onClick={() => setAddOpen(true)}>افزودن حساب</Button>} />
        ) : (
          <div className="ubc-grid">
            {rows.map((a) => {
              const st = STATUS_FA[a.status] || STATUS_FA.new;
              const isBusy = busy === a._id;
              const limited = a.floodWaitUntil && new Date(a.floodWaitUntil) > new Date();
              return (
                <div key={a._id} className={`ubc-acc ${a.active ? '' : 'off'}`}>
                  <div className="ubc-acc-head" style={{ background: a.online ? 'var(--color-success-bg)' : 'var(--color-bg-default)' }}>
                    <div className="ubc-avatar" style={{ background: hueOf(a._id) }}>{initial(a.label)}<i style={{ background: a.online ? UB.ok : '#CBD5E1' }} /></div>
                    <div style={{ minWidth: 0, flex: 1 }}>
                      <div style={{ fontWeight: 800, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{a.label}</div>
                      <div className="fac-muted" style={{ direction: 'ltr', textAlign: 'right', fontFamily: 'monospace' }}>{a.phone}{a.username ? ` · @${a.username}` : ''}</div>
                    </div>
                    <Tooltip title={a.active ? 'روشن' : 'خاموش توسط ادمین'}><Switch size="small" checked={a.active} onChange={(e) => run(a._id, async () => { await userbotService.updateAccount(a._id, { active: e.target.checked }); })} /></Tooltip>
                  </div>
                  <div className="ubc-acc-body">
                    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', marginBottom: 8 }}>
                      <Pill label={st.label} color={st.color} />
                      {limited && <Pill label={`محدود تا ${faDate(a.floodWaitUntil)}`} color={UB.warn} />}
                      {!a.active && <Pill label="خاموش" color={UB.muted} />}
                    </div>
                    <div className="fac-doc-amounts" style={{ marginBottom: 8 }}>
                      {[{ l: 'گروه‌ها', v: a.groupsCount ?? 0 }, { l: 'جواب امروز', v: a.stats?.repliesToday ?? 0 }, { l: 'کل جواب‌ها', v: a.stats?.repliesTotal ?? 0 }].map((x) => (
                        <div key={x.l} className="fac-amt" style={{ textAlign: 'center' }}><span>{x.l}</span><b>{fa(x.v)}</b></div>
                      ))}
                    </div>
                    <div className="fac-muted">شخصیت: {a.persona?.displayName || '—'} · آخرین اتصال: {relTime(a.lastSeenAt)}</div>
                    {a.lastError && <div className="fac-neg" style={{ fontSize: 11.5, marginTop: 4 }}>⚠ {a.lastError}</div>}
                  </div>
                  <div className="ubc-acc-foot">
                    {a.status !== 'active' ? (
                      <Button size="small" variant="contained" startIcon={<LoginIcon />} disabled={isBusy} onClick={() => setLogin(a)}>ورود</Button>
                    ) : (
                      <>
                        <Button size="small" variant="outlined" startIcon={<SyncIcon />} disabled={isBusy} onClick={() => run(a._id, () => userbotService.refreshDialogs(a._id))}>گروه‌ها و کانال‌ها</Button>
                        <Button size="small" variant="outlined" startIcon={<GroupAddIcon />} disabled={isBusy} onClick={() => setJoinFor(a)}>عضویت</Button>
                      </>
                    )}
                    <IconAction title="شخصیت و سقف‌ها" onClick={() => setEdit(a)}><EditIcon fontSize="small" /></IconAction>
                    {a.status === 'active' && <IconAction title="خروج از حساب" color="warning" disabled={isBusy} onClick={() => run(a._id, () => userbotService.logout(a._id))}><LogoutIcon fontSize="small" /></IconAction>}
                    <span style={{ flex: 1 }} />
                    <IconAction title="حذف حساب" color="error" disabled={isBusy} onClick={() => setConfirmDel(a)}><DeleteOutlineIcon fontSize="small" /></IconAction>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </Card>

      <AddAccountDialog open={addOpen} onClose={() => setAddOpen(false)} onCreated={(a) => { setAddOpen(false); load(); setLogin(a); }} />
      {edit && <EditAccountDialog account={edit} onClose={() => setEdit(null)} onSaved={() => { setEdit(null); load(); }} />}
      {login && <LoginDialog account={login} onClose={() => { setLogin(null); load(); onChanged(); }} />}
      {joinFor && <JoinDialog account={joinFor} onClose={() => setJoinFor(null)} onJoined={(m) => { setJoinFor(null); enqueueSnackbar(m, { variant: 'success' }); }} />}
      <ConfirmDialog
        open={!!confirmDel}
        title="حذف حساب"
        message={`حساب «${confirmDel?.label}» حذف شود؟ سشن تلگرامش هم باطل می‌شود.`}
        onConfirm={() => { const a = confirmDel!; setConfirmDel(null); run(a._id, async () => { await userbotService.deleteAccount(a._id); return 'حذف شد'; }); }}
        onCancel={() => setConfirmDel(null)}
      />
    </>
  );
};

const AddAccountDialog: React.FC<{ open: boolean; onClose: () => void; onCreated: (a: UserbotAccount) => void }> = ({ open, onClose, onCreated }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [label, setLabel] = useState('');
  const [phone, setPhone] = useState('+98');
  const [displayName, setDisplayName] = useState('');
  const [bio, setBio] = useState('');
  const [saving, setSaving] = useState(false);
  const submit = async () => {
    setSaving(true);
    try {
      const a = await userbotService.createAccount({ label, phone, persona: { displayName, bio } });
      onCreated(a);
      setLabel(''); setPhone('+98'); setDisplayName(''); setBio('');
    } catch (e) {
      enqueueSnackbar(errMsg(e), { variant: 'error' });
    } finally {
      setSaving(false);
    }
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>افزودن حساب شخصی</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField label="نام داخلی (فقط برای پنل)" value={label} onChange={(e) => setLabel(e.target.value)} fullWidth />
          <TextField label="شمارهٔ تلگرام (با کد کشور)" value={phone} onChange={(e) => setPhone(e.target.value)} fullWidth inputProps={{ dir: 'ltr' }} helperText="مثال: +989121234567" />
          <TextField label="نام نمایشی شخصیت (همان نام تلگرام)" value={displayName} onChange={(e) => setDisplayName(e.target.value)} fullWidth />
          <TextField label="پیشینهٔ کوتاه" value={bio} onChange={(e) => setBio(e.target.value)} fullWidth multiline minRows={2} helperText="مثلاً: چند سال است محصولات مراقبت پوست و آرایشی استفاده می‌کند، پوستش مختلط است" />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>انصراف</Button>
        <Button variant="contained" disabled={saving || !label || phone.length < 8} onClick={submit}>ثبت و ورود</Button>
      </DialogActions>
    </Dialog>
  );
};

const EditAccountDialog: React.FC<{ account: UserbotAccount; onClose: () => void; onSaved: () => void }> = ({ account, onClose, onSaved }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [label, setLabel] = useState(account.label);
  const [persona, setPersona] = useState({ ...account.persona });
  const [limits, setLimits] = useState({ ...account.limits });
  const [saving, setSaving] = useState(false);
  const submit = async () => {
    setSaving(true);
    try {
      await userbotService.updateAccount(account._id, { label, persona, limits });
      enqueueSnackbar('ذخیره شد', { variant: 'success' });
      onSaved();
    } catch (e) {
      enqueueSnackbar(errMsg(e), { variant: 'error' });
    } finally {
      setSaving(false);
    }
  };
  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>شخصیت و سقف‌های «{account.label}»</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0 }}>
          <Grid item xs={12} md={6}><TextField label="نام داخلی" value={label} onChange={(e) => setLabel(e.target.value)} fullWidth /></Grid>
          <Grid item xs={12} md={6}><TextField label="نام نمایشی شخصیت" value={persona.displayName} onChange={(e) => setPersona({ ...persona, displayName: e.target.value })} fullWidth /></Grid>
          <Grid item xs={12}><TextField label="سبک نوشتن" value={persona.style} onChange={(e) => setPersona({ ...persona, style: e.target.value })} fullWidth /></Grid>
          <Grid item xs={12}><TextField label="پیشینه" value={persona.bio} onChange={(e) => setPersona({ ...persona, bio: e.target.value })} fullWidth multiline minRows={2} /></Grid>
          <Grid item xs={12}><TextField label="قواعد اضافهٔ این حساب" value={persona.extraRules} onChange={(e) => setPersona({ ...persona, extraRules: e.target.value })} fullWidth multiline minRows={3} helperText="به قواعد سراسری اضافه می‌شود؛ مثلاً «فقط دربارهٔ مراقبت از پوست نظر بده»" /></Grid>
          <Grid item xs={4}><TextField type="number" label="سقف پاسخ روزانه" value={limits.dailyReplyCap} onChange={(e) => setLimits({ ...limits, dailyReplyCap: Number(e.target.value) })} fullWidth /></Grid>
          <Grid item xs={4}><TextField type="number" label="حداقل فاصلهٔ دو پاسخ (ثانیه)" value={limits.minGapSeconds} onChange={(e) => setLimits({ ...limits, minGapSeconds: Number(e.target.value) })} fullWidth /></Grid>
          <Grid item xs={4}><TextField type="number" label="سقف در هر گروه در ساعت" value={limits.maxPerGroupPerHour} onChange={(e) => setLimits({ ...limits, maxPerGroupPerHour: Number(e.target.value) })} fullWidth /></Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>انصراف</Button>
        <Button variant="contained" startIcon={<SaveIcon />} disabled={saving} onClick={submit}>ذخیره</Button>
      </DialogActions>
    </Dialog>
  );
};

const LoginDialog: React.FC<{ account: UserbotAccount; onClose: () => void }> = ({ account, onClose }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [step, setStep] = useState<'start' | 'code' | 'password' | 'done'>(account.status === 'code_sent' ? 'code' : account.status === 'password_needed' ? 'password' : 'start');
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [note, setNote] = useState('');

  const start = async () => {
    setBusy(true);
    try {
      const r = await userbotService.loginStart(account._id);
      setNote(r.message);
      setStep('code');
    } catch (e) {
      enqueueSnackbar(errMsg(e), { variant: 'error' });
    } finally {
      setBusy(false);
    }
  };
  const sendCode = async () => {
    setBusy(true);
    try {
      const r = await userbotService.loginCode(account._id, code);
      if (r.passwordNeeded) { setStep('password'); setNote('این حساب رمز دومرحله‌ای دارد.'); }
      else { setStep('done'); enqueueSnackbar(r.message, { variant: 'success' }); }
    } catch (e) {
      enqueueSnackbar(errMsg(e), { variant: 'error' });
    } finally {
      setBusy(false);
    }
  };
  const sendPassword = async () => {
    setBusy(true);
    try {
      const r = await userbotService.loginPassword(account._id, password);
      setStep('done');
      enqueueSnackbar(r.message, { variant: 'success' });
    } catch (e) {
      enqueueSnackbar(errMsg(e), { variant: 'error' });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>ورود به حساب «{account.label}»</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2, direction: 'ltr', textAlign: 'right' }}>{account.phone}</Typography>
        {note && <Alert severity="info" sx={{ mb: 2 }}>{note}</Alert>}
        {step === 'start' && <Typography variant="body2">تلگرام یک کد ورود به این شماره می‌فرستد (معمولاً داخل خود اپ تلگرام، وگرنه پیامک).</Typography>}
        {step === 'code' && <TextField autoFocus label="کد ورود" value={code} onChange={(e) => setCode(e.target.value)} fullWidth inputProps={{ dir: 'ltr', inputMode: 'numeric' }} helperText="کد را همان‌طور که تلگرام فرستاده وارد کنید" />}
        {step === 'password' && <TextField autoFocus type="password" label="رمز دومرحله‌ای (Cloud Password)" value={password} onChange={(e) => setPassword(e.target.value)} fullWidth inputProps={{ dir: 'ltr' }} />}
        {step === 'done' && <Alert severity="success">ورود انجام شد. سرویس ربات تا چند ثانیهٔ دیگر حساب را وصل می‌کند و گروه‌هایش را می‌خواند.</Alert>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{step === 'done' ? 'بستن' : 'بعداً'}</Button>
        {step === 'start' && <Button variant="contained" disabled={busy} onClick={start}>ارسال کد</Button>}
        {step === 'code' && <><Button disabled={busy} onClick={start}>ارسال دوباره</Button><Button variant="contained" disabled={busy || !code} onClick={sendCode}>تأیید کد</Button></>}
        {step === 'password' && <Button variant="contained" disabled={busy || !password} onClick={sendPassword}>ورود</Button>}
      </DialogActions>
    </Dialog>
  );
};

const JoinDialog: React.FC<{ account: UserbotAccount; onClose: () => void; onJoined: (m: string) => void }> = ({ account, onClose, onJoined }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [link, setLink] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      onJoined(await userbotService.join(account._id, link));
    } catch (e) {
      enqueueSnackbar(errMsg(e), { variant: 'error' });
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>عضویت «{account.label}» در گروه</DialogTitle>
      <DialogContent>
        <TextField autoFocus label="لینک دعوت یا یوزرنیم گروه" value={link} onChange={(e) => setLink(e.target.value)} fullWidth inputProps={{ dir: 'ltr' }} helperText="t.me/+xxxx یا @groupname" sx={{ mt: 1 }} />
        <Alert severity="warning" sx={{ mt: 2 }}>حساب‌های تازه را یک‌باره در گروه‌های زیاد عضو نکنید؛ تلگرام محدود می‌کند. روزی چند گروه کافی است.</Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>انصراف</Button>
        <Button variant="contained" disabled={busy || !link} onClick={submit}>عضویت</Button>
      </DialogActions>
    </Dialog>
  );
};

// ------------------------------------------------------------------ گروه‌ها

const GroupsTab: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [rows, setRows] = useState<UserbotGroup[]>([]);
  const [loading, setLoading] = useState(true);
  const [edit, setEdit] = useState<UserbotGroup | null>(null);
  const [del, setDel] = useState<UserbotGroup | null>(null);
  const [deleting, setDeleting] = useState(false);
  const [filter, setFilter] = useState('');
  const [only, setOnly] = useState<'all' | 'on' | 'off'>('all');

  const load = useCallback(async () => {
    setLoading(true);
    try { setRows(await userbotService.groups()); }
    catch (e) { enqueueSnackbar(errMsg(e), { variant: 'error' }); }
    finally { setLoading(false); }
  }, [enqueueSnackbar]);
  useEffect(() => { load(); }, [load]);

  const toggle = async (g: UserbotGroup, enabled: boolean) => {
    try {
      await userbotService.updateGroup(g._id, { enabled });
      setRows((r) => r.map((x) => (x._id === g._id ? { ...x, enabled } : x)));
    } catch (e) { enqueueSnackbar(errMsg(e), { variant: 'error' }); }
  };

  const shown = useMemo(() => rows.filter((g) => {
    if (only === 'on' && !g.enabled) return false;
    if (only === 'off' && g.enabled) return false;
    if (!filter) return true;
    return (g.title || '').includes(filter) || (g.username || '').includes(filter) || g.chatId.includes(filter);
  }), [rows, filter, only]);

  const enabledCount = rows.filter((g) => g.enabled).length;
  const noAccount = rows.filter((g) => g.enabled && !g.accountIds.some((a) => a.online)).length;
  const sentTotal = rows.reduce((s, g) => s + (g.stats.sent || 0), 0);
  const seenTotal = rows.reduce((s, g) => s + (g.stats.seen || 0), 0);

  return (
    <>
      {rows.length > 0 && (
        <>
          <Kpis items={[
            { label: 'گروه‌های فعال', raw: <>{fa(enabledCount)} <span className="fac-muted">/ {fa(rows.length)}</span></>, value: null, color: enabledCount ? 'green' : 'gray', help: 'فقط در گروه‌های فعال جواب داده می‌شود؛ بقیه فقط برای تحلیل بازار خوانده می‌شوند' },
            { label: 'پیام‌های دیده‌شده', value: seenTotal, count: true, color: 'blue', help: 'کل پیام‌هایی که دستیار در همهٔ گروه‌ها خوانده' },
            { label: 'جواب فرستاده‌شده', value: sentTotal, count: true, color: 'purple', help: 'مجموع پیام‌های ارسالی در همهٔ گروه‌ها' },
            { label: 'گروه فعال بدون حساب آنلاین', value: noAccount, count: true, color: noAccount ? 'orange' : 'gray', help: 'گروه روشن است ولی هیچ حساب آنلاینی عضوش نیست ⇒ عملاً کار نمی‌کند' },
          ]} />
          {noAccount > 0 && <Insights items={[{ tone: 'warn', text: <><b>{fa(noAccount)}</b> گروه فعال است ولی هیچ حساب آنلاینی در آن عضو نیست؛ تا یک حساب وارد و عضو نشود، پیام‌های آن گروه جوابی نمی‌گیرند.</> }]} />}
        </>
      )}
      <Card title="گروه‌ها" sub="از عضویت‌های حساب‌ها کشف می‌شوند · تا فعال نکنید هیچ جوابی داده نمی‌شود" icon={<GroupsIcon />}
        actions={<>
          {([['all', 'همه'], ['on', 'فعال'], ['off', 'غیرفعال']] as const).map(([k, l]) => (
            <Button key={k} size="small" variant={only === k ? 'contained' : 'outlined'} onClick={() => setOnly(k)}>{l}</Button>
          ))}
          <TextField size="small" placeholder="جست‌وجوی گروه…" value={filter} onChange={(e) => setFilter(e.target.value)} sx={{ minWidth: 180 }} />
          <IconAction title="به‌روزرسانی" onClick={load}><RefreshIcon /></IconAction>
        </>}>
        {loading && shown.length === 0 ? <Loading /> : shown.length === 0 ? (
          <EmptyHint icon={<GroupsIcon />} title={rows.length ? 'با این فیلتر گروهی نیست' : 'گروهی پیدا نشد'} hint={rows.length ? 'فیلتر را عوض کنید.' : 'در تب حساب‌ها روی «گروه‌ها و کانال‌ها» بزنید تا عضویت‌های هر حساب از تلگرام خوانده شود.'} />
        ) : (
          <div className="fac-rows-wrap"><div className="fac-rows" style={{ minWidth: 980 }}>
            <div className="fac-row head" style={{ gridTemplateColumns: '54px minmax(180px, 1.6fr) 150px 110px 150px minmax(210px, 1fr) 76px' }}>
              <span>فعال</span><span>گروه</span><span>حالت ارسال</span><span>سخت‌گیری</span><span>حساب‌های عضو</span><span>آمار</span><span />
            </div>
            {shown.map((g) => {
              const online = g.accountIds.filter((a) => a.online).length;
              return (
                <div key={g._id} className={`fac-row ${g.enabled ? '' : 'inactive'}`} style={{ gridTemplateColumns: '54px minmax(180px, 1.6fr) 150px 110px 150px minmax(210px, 1fr) 76px', cursor: 'default' }}>
                  <span><Tooltip title={g.enabled ? 'فعال — پیام‌ها پردازش می‌شوند' : 'غیرفعال — فقط خوانده می‌شود'}><Switch size="small" checked={g.enabled} onChange={(e) => toggle(g, e.target.checked)} /></Tooltip></span>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
                    <span className="ubc-avatar sm" style={{ background: hueOf(g.chatId) }}>{initial(g.title || g.chatId)}</span>
                    <span style={{ minWidth: 0 }}>
                      <b style={{ display: 'block', fontWeight: 800, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{g.title || g.chatId}</b>
                      <small className="fac-muted" style={{ direction: 'ltr', display: 'block', textAlign: 'right' }}>{g.username ? `@${g.username}` : g.chatId}{g.membersCount != null ? ` · ${fa(g.membersCount)} عضو` : ''}</small>
                    </span>
                  </span>
                  <span><Pill label={g.mode === 'auto' ? 'ارسال خودکار' : 'پیش‌نویس با تأیید'} color={g.mode === 'auto' ? UB.ok : UB.info} /></span>
                  <span className="fac-muted">{g.sensitivity === 'high' ? 'زیاد' : g.sensitivity === 'low' ? 'کم' : 'عادی'}</span>
                  <span>
                    <Tag
                      label={g.accountIds.length ? `${fa(online)}/${fa(g.accountIds.length)} آنلاین` : 'بدون حساب'}
                      color={g.accountIds.length ? (online ? 'success' : 'warning') : 'error'}
                      title={g.accountIds.map((a) => a.label).join('، ') || 'هیچ حسابی عضو این گروه نیست'}
                    />
                  </span>
                  <span style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
                    {[{ l: 'دیده', v: g.stats.seen }, { l: 'کاندیدا', v: g.stats.candidates }, { l: 'تأیید', v: g.stats.gated }, { l: 'ارسال', v: g.stats.sent }, { l: 'امروز', v: g.stats.sentToday }].map((x) => (
                      <span key={x.l} className="ubc-mini"><b>{fa(x.v)}</b><i>{x.l}</i></span>
                    ))}
                    <small className="fac-muted" style={{ flexBasis: '100%' }}>آخرین پیام {relTime(g.stats.lastMessageAt)} · آخرین جواب {relTime(g.stats.lastReplyAt)}</small>
                  </span>
                  <span style={{ display: 'flex', gap: 2 }}>
                    <IconAction title="تنظیم گروه" onClick={() => setEdit(g)}><EditIcon fontSize="small" /></IconAction>
                    <IconAction title="حذف گروه" color="error" onClick={() => setDel(g)}><DeleteOutlineIcon fontSize="small" /></IconAction>
                  </span>
                </div>
              );
            })}
          </div></div>
        )}
      </Card>
      {edit && <GroupDialog group={edit} onClose={() => setEdit(null)} onSaved={() => { setEdit(null); load(); }} />}
      <Dialog open={!!del} onClose={() => !deleting && setDel(null)} fullWidth maxWidth="xs">
        <DialogTitle>حذف گروه «{del?.title || del?.chatId}»</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 1 }}>
            <b>خروج و حذف:</b> همهٔ حساب‌های دستیار ({fa(del?.accountIds.length ?? 0)} حساب) در تلگرام از این گروه خارج می‌شوند، پیش‌نویس‌های بازش منقضی و گروه از فهرست حذف می‌شود.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <b>فقط از فهرست:</b> حساب‌ها عضو می‌مانند و پیامی پردازش نمی‌شود؛ با «به‌روزرسانی گروه‌ها» دوباره کشف می‌شود.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button disabled={deleting} onClick={() => setDel(null)}>انصراف</Button>
          <Button
            disabled={deleting}
            onClick={async () => {
              const g = del!; setDeleting(true);
              try { enqueueSnackbar(await userbotService.deleteGroup(g._id, false), { variant: 'success' }); setDel(null); load(); }
              catch (e) { enqueueSnackbar(errMsg(e), { variant: 'error' }); }
              finally { setDeleting(false); }
            }}
          >
            فقط از فهرست
          </Button>
          <Button
            variant="contained" color="error" disabled={deleting}
            startIcon={deleting ? <CircularProgress size={14} /> : <LogoutIcon />}
            onClick={async () => {
              const g = del!; setDeleting(true);
              try { enqueueSnackbar(await userbotService.deleteGroup(g._id, true), { variant: 'success' }); setDel(null); load(); }
              catch (e) { enqueueSnackbar(errMsg(e), { variant: 'error' }); }
              finally { setDeleting(false); }
            }}
          >
            خروج و حذف
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const GroupDialog: React.FC<{ group: UserbotGroup; onClose: () => void; onSaved: () => void }> = ({ group, onClose, onSaved }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [form, setForm] = useState({
    enabled: group.enabled,
    mode: group.mode,
    sensitivity: group.sensitivity,
    contextNotes: group.contextNotes || '',
    preferredAccountId: group.preferredAccountId?._id || '',
    cooldown: { ...group.cooldown },
  });
  const [saving, setSaving] = useState(false);
  const [confirmForget, setConfirmForget] = useState(false);
  const submit = async () => {
    setSaving(true);
    try {
      await userbotService.updateGroup(group._id, { ...form, preferredAccountId: form.preferredAccountId || null });
      enqueueSnackbar('ذخیره شد', { variant: 'success' });
      onSaved();
    } catch (e) {
      enqueueSnackbar(errMsg(e), { variant: 'error' });
    } finally {
      setSaving(false);
    }
  };
  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>تنظیم گروه «{group.title || group.chatId}»</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0 }}>
          <Grid item xs={12} md={4}>
            <FormControlLabel control={<Switch checked={form.enabled} onChange={(e) => setForm({ ...form, enabled: e.target.checked })} />} label="فعال" />
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth size="small">
              <InputLabel>حالت</InputLabel>
              <Select label="حالت" value={form.mode} onChange={(e) => setForm({ ...form, mode: e.target.value as 'draft' | 'auto' })}>
                <MenuItem value="draft">پیش‌نویس — با تأیید ادمین</MenuItem>
                <MenuItem value="auto">ارسال خودکار (بدون تأیید)</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth size="small">
              <InputLabel>سخت‌گیری دروازه‌بان</InputLabel>
              <Select label="سخت‌گیری دروازه‌بان" value={form.sensitivity} onChange={(e) => setForm({ ...form, sensitivity: e.target.value as any })}>
                <MenuItem value="low">کم — بیشتر جواب بده</MenuItem>
                <MenuItem value="normal">عادی</MenuItem>
                <MenuItem value="high">زیاد — فقط موارد مطمئن</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {form.mode === 'auto' && (
            <Grid item xs={12}><Alert severity="warning">در حالت خودکار، پاسخ‌ها بدون دیدن شما ارسال می‌شوند. پیشنهاد: اول چند روز در حالت پیش‌نویس کیفیت را ببینید.</Alert></Grid>
          )}
          <Grid item xs={12} md={6}>
            <FormControl fullWidth size="small">
              <InputLabel>حساب ترجیحی</InputLabel>
              <Select label="حساب ترجیحی" value={form.preferredAccountId} onChange={(e) => setForm({ ...form, preferredAccountId: String(e.target.value) })}>
                <MenuItem value="">خودکار (کم‌کارترین حساب)</MenuItem>
                {group.accountIds.map((a) => <MenuItem key={a._id} value={a._id}>{a.label}</MenuItem>)}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4} md={2}><TextField size="small" type="number" label="فاصله برای هر نفر (دقیقه)" value={form.cooldown.perUserMinutes} onChange={(e) => setForm({ ...form, cooldown: { ...form.cooldown, perUserMinutes: Number(e.target.value) } })} fullWidth /></Grid>
          <Grid item xs={4} md={2}><TextField size="small" type="number" label="فاصلهٔ دو پاسخ در گروه (دقیقه)" value={form.cooldown.perGroupMinutes} onChange={(e) => setForm({ ...form, cooldown: { ...form.cooldown, perGroupMinutes: Number(e.target.value) } })} fullWidth /></Grid>
          <Grid item xs={4} md={2}><TextField size="small" type="number" label="سقف روزانه" value={form.cooldown.maxPerDay} onChange={(e) => setForm({ ...form, cooldown: { ...form.cooldown, maxPerDay: Number(e.target.value) } })} fullWidth /></Grid>
          <Grid item xs={12}>
            <TextField label="یادداشت برای مدل دربارهٔ این گروه" value={form.contextNotes} onChange={(e) => setForm({ ...form, contextNotes: e.target.value })} fullWidth multiline minRows={3}
              helperText="مثلاً: گروه مراقبت پوست خانم‌های تهران؛ لحن خیلی خودمانی؛ ادمین‌ها با تبلیغ حساس‌اند؛ فقط وقتی کسی صریح پرسید اسم سایت را بگو" />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Button color="error" size="small" onClick={() => setConfirmForget(true)}>حذف از فهرست</Button>
        <Box>
          <Button onClick={onClose}>انصراف</Button>
          <Button variant="contained" startIcon={<SaveIcon />} disabled={saving} onClick={submit}>ذخیره</Button>
        </Box>
      </DialogActions>
      <ConfirmDialog
        open={confirmForget}
        title="حذف گروه از فهرست"
        message="گروه از فهرست حذف می‌شود (حساب‌ها از گروه خارج نمی‌شوند و با به‌روزرسانی دوباره کشف می‌شود)."
        onConfirm={async () => { setConfirmForget(false); try { enqueueSnackbar(await userbotService.deleteGroup(group._id, false), { variant: 'success' }); onSaved(); } catch (e) { enqueueSnackbar(errMsg(e), { variant: 'error' }); } }}
        onCancel={() => setConfirmForget(false)}
      />
    </Dialog>
  );
};

// ------------------------------------------------------------------ آزمایش

const TestTab: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [text, setText] = useState('سلام بچه‌ها یه سرم ویتامین C اصل میخوام بخرم از کجا بخرم که تقلبی نباشه؟');
  const [context, setContext] = useState('');
  const [groups, setGroups] = useState<UserbotGroup[]>([]);
  const [groupId, setGroupId] = useState('');
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState<UserbotDryRun | null>(null);
  useEffect(() => { userbotService.groups().then(setGroups).catch(() => undefined); }, []);

  const samples: Array<[string, string]> = [
    ['خریدار واقعی', 'سلام بچه‌ها یه سرم ویتامین C اصل میخوام بخرم از کجا بخرم که تقلبی نباشه؟'],
    ['سؤال قیمت', 'قیمت ضدآفتاب SPF50 لاروش‌پوزای الان چنده؟'],
    ['فروشنده (باید رد شود)', 'فروش عمده رژ لب و کرم آبرسان قیمت مناسب پی‌وی بدید 🔥'],
    ['بی‌ربط (باید رد شود)', 'بچه‌ها فردا دورهمی داریم کی هست؟'],
  ];

  const run = async () => {
    setBusy(true);
    setResult(null);
    try {
      const ctx = context.split('\n').map((l) => l.trim()).filter(Boolean).map((l) => {
        const m = /^(.+?):\s*(.+)$/.exec(l);
        return m ? { senderName: m[1], text: m[2], isOurs: /^(ما|we)$/i.test(m[1]) } : { senderName: 'عضو', text: l, isOurs: false };
      });
      setResult(await userbotService.dryRun({ text, groupId: groupId || undefined, context: ctx }));
    } catch (e) {
      enqueueSnackbar(errMsg(e), { variant: 'error' });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={5}>
        <Card title="پیام آزمایشی" sub="هیچ چیزی به تلگرام نمی‌رود؛ ولی هزینهٔ واقعی هوش مصنوعی دارد" icon={<ScienceIcon />}>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 10 }}>
            {samples.map(([l, t]) => <Button key={l} size="small" variant="outlined" onClick={() => setText(t)}>{l}</Button>)}
          </div>
          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel>گروه (برای یادداشت و سخت‌گیری)</InputLabel>
            <Select label="گروه (برای یادداشت و سخت‌گیری)" value={groupId} onChange={(e) => setGroupId(String(e.target.value))}>
              <MenuItem value="">— بدون گروه —</MenuItem>
              {groups.map((g) => <MenuItem key={g._id} value={g._id}>{g.title || g.chatId}</MenuItem>)}
            </Select>
          </FormControl>
          <TextField label="پیام‌های قبلی (اختیاری؛ هر خط «نام: متن»)" value={context} onChange={(e) => setContext(e.target.value)} fullWidth multiline minRows={3} sx={{ mb: 2 }} helperText="برای پیام‌های خودمان از «ما: …» استفاده کنید" />
          <TextField label="پیام هدف" value={text} onChange={(e) => setText(e.target.value)} fullWidth multiline minRows={3} sx={{ mb: 2 }} />
          <Button variant="contained" startIcon={busy ? <CircularProgress size={16} color="inherit" /> : <ScienceIcon />} disabled={busy || !text.trim()} onClick={run}>اجرای خط لوله</Button>
        </Card>
      </Grid>
      <Grid item xs={12} md={7}>
        {!result && !busy && (
          <Card title="نتیجه" sub="سه مرحله جدا، با مدل و زمان و هزینهٔ خودش" icon={<PlaylistAddCheckRoundedIcon />}>
            <EmptyHint icon={<ScienceIcon />} title="هنوز اجرا نشده" hint="یک پیام بنویسید یا یکی از نمونه‌ها را بزنید و «اجرای خط لوله» را کلیک کنید." />
          </Card>
        )}
        {busy && <Card title="نتیجه" icon={<PlaylistAddCheckRoundedIcon />}><Loading /></Card>}
        {result && (
          <>
            <Insights items={[
              result.prefilter.pass === false
                ? { tone: 'bad', text: <>این پیام در <b>فیلتر محلی</b> متوقف شد ({result.prefilter.reason}) و هیچ هزینه‌ای برای هوش مصنوعی نداشت. یعنی در گروه واقعی هم نادیده گرفته می‌شد.</> }
                : result.gate && result.gate.decision !== 'reply'
                  ? { tone: 'warn', text: <><b>دروازه‌بان</b> گفت جواب ندهیم: {result.gate.reason}. اگر فکر می‌کنید باید جواب می‌داد، آستانهٔ اطمینان را در تنظیمات پایین بیاورید.</> }
                  : result.writer?.skip
                    ? { tone: 'warn', text: <><b>نویسنده</b> ترجیح داد جواب ندهد: {result.writer.note}</> }
                    : result.writer?.text
                      ? { tone: 'good', text: <>این پیام جواب می‌گرفت. متن پیشنهادی پایین آمده؛ در گروه واقعی با تأخیر و تایپینگ طبیعی فرستاده می‌شد.</> }
                      : { tone: 'info', text: 'خط لوله کامل اجرا نشد؛ جزئیات پایین را ببینید.' },
            ]} />
            <Card title="مرحله‌به‌مرحله" sub="دقیقاً همان مسیری که یک پیام واقعی طی می‌کند" icon={<PlaylistAddCheckRoundedIcon />}>
              <div className="fac-lines">
                <div className="fac-line">
                  <span className="fac-line-code">۰</span>
                  <div>
                    <div className="fac-line-title">فیلتر محلی {result.prefilter.pass ? <FacTag color="green">عبور کرد</FacTag> : <FacTag color="red">متوقف شد</FacTag>}</div>
                    <div className="fac-line-note">رایگان و بدون هوش مصنوعی{result.prefilter.reason ? ` · ${result.prefilter.reason}` : ''}{result.prefilter.matched?.length ? ` · نشانه‌ها: ${result.prefilter.matched.join('، ')}` : ''}</div>
                    {result.local && <div style={{ marginTop: 6 }}><LocalChips local={result.local} /></div>}
                  </div>
                  <div />
                </div>
                {result.gate && (
                  <div className="fac-line">
                    <span className="fac-line-code">۱</span>
                    <div>
                      <div className="fac-line-title">دروازه‌بان {result.gate.decision === 'reply' ? <FacTag color="green">جواب بده</FacTag> : <FacTag color="red">نادیده بگیر</FacTag>}<small>{INTENT_FA[result.gate.intent] || result.gate.intent}</small></div>
                      <div className="fac-line-note">{result.gate.reason} — اطمینان {fa(Math.round(result.gate.confidence * 100))}٪ از آستانهٔ {fa(Math.round((result.threshold || 0) * 100))}٪ · {result.gate.model} · {fa(result.gate.ms)}ms · {fa(result.gate.costUsd.toFixed(5))}$</div>
                    </div>
                    <div />
                  </div>
                )}
                {result.writer && (
                  <div className="fac-line">
                    <span className="fac-line-code">۲</span>
                    <div>
                      <div className="fac-line-title">نویسنده {result.writer.skip ? <FacTag color="orange">پیشنهاد می‌کند جواب ندهیم</FacTag> : <FacTag color="green">جواب نوشت</FacTag>}<small>{result.persona?.displayName || '—'}</small></div>
                      {result.writer.text && <div style={{ marginTop: 6 }}><Bubble ours who={result.persona?.displayName || 'دستیار'} text={result.writer.text} /></div>}
                      <div className="fac-line-note">{result.writer.note} · {result.writer.model} · {fa(result.writer.ms)}ms · {fa(result.writer.costUsd.toFixed(5))}$</div>
                    </div>
                    <div />
                  </div>
                )}
              </div>
              {result.error && <Alert severity="warning" sx={{ mt: 1.5 }}>{result.error}</Alert>}
              <p className="fac-note">هزینهٔ کل این آزمایش: {fa(((result.gate?.costUsd || 0) + (result.writer?.costUsd || 0)).toFixed(5))}$ — از بودجهٔ روزانه کم می‌شود.</p>
            </Card>
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default UserbotCenter;
